// extracted by mini-css-extract-plugin
export var aside = "Aside-module--aside--L09Vi";
export var asideNoRule = "Aside-module--asideNoRule--R-e+v";
export var bxTextTruncateEnd = "Aside-module--bx--text-truncate--end--X1q2T";
export var bxTextTruncateFront = "Aside-module--bx--text-truncate--front--Acoet";